import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AlertController, LoadingController, NavController } from '@ionic/angular';
import { stat } from 'fs';
import { Subject, from } from 'rxjs';
import { ApiService } from 'src/app/providers/apiService/api.service';
import { EventsService } from 'src/app/providers/events/events.service';
import { StorageService } from 'src/app/providers/storageService/storage.service';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonModal } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { environment } from 'src/environments/environment';
import { formatDate } from "@angular/common";
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-submissions',
  templateUrl: './submissions.page.html',
  styleUrls: ['./submissions.page.scss'],
})
export class SubmissionsPage implements OnInit {
  charsAllowed = 3000;
  @ViewChild(IonModal) modalFileSubmissions: IonModal;
  private unsubscribe$ = new Subject<void>(); 
  year:number;
  submissionList:any;
  user:any;
  fullname: string;
  email:string;
  username:string;
  submissionDisplay:boolean;
  submissionType:string;
  subPendingButtonFill:string;
  subCompletedButtonFill:string;
  subRejectedButtonFill:string;
  savedCount: any;
  currentSavedSubmission: any;
  submissionState:string;
  buttonSubmissionState:string;
  submissionButtonIcon:string;
  images:any = [];
  files:any = [];
  fileCount: number = 0;
  submissionForm: FormGroup;
  isFileSubmissionModalOpen: boolean = false;
  portalVersion:string;
  imgBaseUrl = environment.imgBaseUrl;

  constructor(
    public storageService: StorageService,
    private apiService: ApiService,
    public events: EventsService,
    public navCtrl: NavController,
    private loadingCtrl: LoadingController,
    public formBuilder: FormBuilder,
    private alertController: AlertController,
    private loadingController: LoadingController,
    public router: Router,
    ) {

      this.storageService.get('portalVersion').then(res => {
        this.portalVersion = res;
      });

      this.submissionForm = this.formBuilder.group({
      User: [''],
      images: [[], [Validators.required]],
      comments: ['', [Validators.maxLength(this.charsAllowed)]],
      type: ['portal'],
      submissionid: [''],
      version: [''], 
      platform: 'web' 
    });
  }

    async ionViewDidEnter() {
      document.title = "Medbill Client Portal - Submissions";
      this.submissionForm.controls.version.setValue(this.portalVersion);
      this.year = new Date().getFullYear();   
      this.getUser();
      this.submissionType = 'Received';
      this.subPendingButtonFill = 'solid';
      this.subCompletedButtonFill = 'clear';
      this.subRejectedButtonFill = 'clear';
      this.submissionList = await this.getSubmissions('0', this.submissionType);
      this.submissionDisplay = false;
      //console.log(this.submissionList);
      if (this.submissionList.length > 0)
      {
        this.submissionDisplay = true;
      }  


      this.checkSavedSubmissions();
      this.submissionState = 'New Submission';
      this.buttonSubmissionState = 'New Submission';
      this.submissionButtonIcon = "add-circle";
      
    }
  
    async ngOnInit() {
    
      
    }
  
    async getUser() {
      await this.storageService
        .getObject('userInfo')
        .then((result) => {
          if (result != null) {
            this.user = result;
            //console.log('user: ',this.user);
            this.events.publish('user:active', this.user);
          }
        })
        .catch((e) => {
          // Handle errors here
        });
  
      await this.storageService
      .getObject('mbeUser')
      .then((result) => {
        if (result != null) {
          this.user = result;
          this.fullname = this.user.first_name + ' ' + this.user.last_name;
          this.email = this.user.email;
          this.username = this.user.username;
        }
      })
      .catch((e) => {
        // Handle errors here
      });

    }

    async changeType(type)
    {
      let statusText = '';
      if (type == 0)
      {
        statusText = 'Received';
        this.subPendingButtonFill = 'solid';
        this.subCompletedButtonFill = 'clear';
        this.subRejectedButtonFill = 'clear';
      }
      else if (type == 2)
      {
        statusText = 'Downloaded by Medbill';
        this.subPendingButtonFill = 'clear';
        this.subCompletedButtonFill = 'solid';
        this.subRejectedButtonFill = 'clear';
      }
      else
      {
        statusText = 'Returned for Action';
        this.subPendingButtonFill = 'clear';
        this.subCompletedButtonFill = 'clear';
        this.subRejectedButtonFill = 'solid';
      }
      this.submissionList = await this.getSubmissions(type, statusText);
      //console.log(this.submissionList);
      this.submissionType = statusText;
      this.submissionDisplay = false;
      if (this.submissionList.length > 0)
      {
        this.submissionDisplay = true;
      }
    }

    async getSubmissions(status:string, statusText:string) {
      const loading = await this.loadingCtrl.create({
        message: 'Loading ' + statusText + ' Submissions.  Please Wait...',
        mode: 'ios',
      });
      const params = {
        page: 1,
        perPage: 100,
        status,
      };
      loading.present();
      return new Promise((resolve, reject) => {
        this.apiService.post('submission-list', params).subscribe(
          (res) => {
            loading.dismiss();
            if (res.error === false) {
              resolve(res.data.submissions);
            } else {
              reject(new Error('API response error'));
            }
          },
          (err) => {
            loading.dismiss();
            reject(err);
          }
        );
      });
    }    
        
    async showSubDetail(data, i) {
      //console.log(data);
      let imgData = '';
      let imgIndex = 1;

      data.Page.forEach(image => {
        if (data.Data.type == 'basic')
        {
          imgData += '<strong>Billing Sheet '+imgIndex+' of '+data.Page.length+':</strong><br><img src="'+this.imgBaseUrl+image.filename+'"><br>';
        }
        else
        {
          imgData += '<strong>Patient Sticker:</strong><br><img src="'+this.imgBaseUrl+image.filename+'"><br>';
        }
        imgIndex++;
      });
      if (data.Data.type == 'portal')
      {
        imgData = '<strong>You uploaded:</strong><br>'+data.Data.portal_list;
      }
      let subDate = new Date(data.Data.date);
      const detail = await this.alertController.create({
        header: 'Submission #'+data.Data.id+' Detail',
        message: 
        '<strong>Date: </strong>'+formatDate(subDate,'fullDate','en-AU')+'<br>'+
        '<strong>Type: </strong>'+data.Data.type+'<br><br>'+
        '<strong>Comments:</strong><br>'+
        data.Data.comments+'<br><br>'+
        imgData,
        cssClass: 'alertSubmissionDetail',
        buttons: [
          
          {
            text: 'OK',
            role: 'confirm',
            handler: () => {
            },
          },
        ],
      });
      await detail.present();
    }      

    pickFiles = async () => {
      if (!this.currentSavedSubmission) 
      {
        await this.createSubmission();
      }
      const result = await FilePicker.pickFiles({
        multiple: true,
        readData: true,
        types: ['text/csv','application/pdf','application/msword','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.openxmlformats-officedocument.wordprocessingml.document','image/png','image/jpeg']
      }).then( picked => {
        this.fileCount += picked.files.length;
        //console.log(this.fileCount);
        // Show loading spinner
        let loading = null;
        this.loadingController.create({
          message: 'Adding Billing File to Submission. Please wait...',
          spinner: "circles"
          // You can customize options here
          }).then((loadingInstance) => {
            loading = loadingInstance;
            loading.present();
            picked.files.forEach(image => {
              if (image.size >= 104857600)
              {
                //console.log(image.size);
                //too big!

                this.presentFailedSubmissionAlert('File Error','File: '+image.name+'<br>Size: '+(Math.round((image.size*0.000001)*100) / 100).toFixed(2)+'MB<br>File size is limited to 100MB.  Please reduce your file size and try again.');
                this.fileCount--;
              }
              else
              {
                //console.log('i: ',image);
                this.convertBlobToBase64(image.blob).then( dataurl => {      
                  var thefile = {            
                    data: image.data,
                    base64: dataurl,
                    mimeType: image.mimeType, 
                    name: image.name
                  }
              
                  this.addFile(thefile);
                  //this.files.push(thefile);
                
               });
              }
          }); 
          
          loading.dismiss();   
        });
      });
      
    }

    addFile(theFile)
    {
      //add file to submission (new backend API function)
      var params;  
      params = {
        isportal: 'true',
        image: theFile,
        comments: this.submissionForm.value.comments,
        submissionid: this.currentSavedSubmission,
      };  
      // Show loading spinner
      let loading = null;
      this.loadingController.create({
        message: 'Adding Image to Submission. Please wait...',
        spinner: "circles"
        // You can customize options here
      }).then((loadingInstance) => {
        loading = loadingInstance;
        loading.present();
        this.apiService.post('submission_add_image', params).subscribe(
          (res) => {
            //console.log('image');
            //console.log(res);
            if (res.error === false) {
              if (res.filename) 
              {
                var file = {            
                  preview: this.imgBaseUrl + res.filename,
                  fileId: res.imageid,
                  name: res.filename,
                  originalname: res.filename
                }
                
                loading.dismiss();
                this.files.push(file);
                
                this.updateFileCount();
                this.presentSuccessfulSubmissionAlert('File Added','File ' + res.filename + ' added successfully.', false);
             
                this.submissionState = 'Resume Submission '+this.currentSavedSubmission;
                this.buttonSubmissionState = 'Resume Submission';
                this.submissionButtonIcon = "play-circle";
              }
            }
            else
            {
              this.presentFailedSubmissionAlert('File Error','There was a problem adding your file:<br><br>'+res);
              loading.dismiss();
            }
          },
          (err) => { 
            //console.log('err');
          }
        ); 
      });            
    }

    convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
      const reader = new FileReader;
      reader.onerror = reject;
      reader.onload = () => {
          resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
    
    onRemoveImage(imageIndex) {
      let Subject = 'Remove Billing File?';
      let Message = 'Are you sure you want to remove this billing sheet file?<br><br>This will remove this file from your submission permanently.<br><br><strong>This cannot be undone!</strong>';
      if (!imageIndex && imageIndex!=0)
      {
        //console.log('empty!');
        Subject = 'Remove ALL Billing Files?';
        Message = 'Are you sure you want to remove ALL billing sheet files?<br><br>This will remove '+this.fileCount+' files from your submission permanently.<br><br><strong>This cannot be undone!</strong>';
      }
      this.removeImageAlert(Subject,Message,imageIndex);
    }

    async removeImageAlert(subject,message,imageIndex) {
      const alert = await this.alertController.create({
        cssClass: 'missingAlert centreAlert',
        header: subject,
        message: message,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
            },
          },
          {
            text: 'Confirm',
            handler: () => {
              var params;  
              if (!imageIndex && imageIndex!=0)
              {
                //remove all images from server and from pages table
                params = {
                  isportal: true,
                  removeall: true,
                  submissionid: this.currentSavedSubmission,
                };  
                this.apiService.post('submission_del_image', params).subscribe(
                  (res) => {
                    //console.log(res);
                    if (res.error === false) {
                      this.files = [];
                      this.updateFileCount();
                      if (res.image > 1)
                      {
                        this.presentSuccessfulSubmissionAlert('Files cleared','Successfully removed '+res.image+' billing sheet files.', false);
                      }
                      else
                      {
                        this.presentSuccessfulSubmissionAlert('File cleared','Successfully removed 1 billing sheet file.', false);
                      }
                    }
                    else
                    {
                      this.presentFailedSubmissionAlert('Error','There was a problem removing your billing file(s):<br><br>'+res.error.message);
                    }
                  },
                  (err) => { 
                    this.presentFailedSubmissionAlert('Error','There was a problem removing your billing file(s).');
                  }    
                );
              }
              else
              {
                //remove one image from server and from pages table              
                params = {
                  imageid: this.files[imageIndex].fileId,
                  isportal: true,
                  removeall: false,
                  submissionid: this.currentSavedSubmission,
                };  
                this.apiService.post('submission_del_image', params).subscribe(
                  (res) => {
                    //console.log(res);
                    if (res.error === false) {
                      this.files.splice(imageIndex, 1);
                      this.updateFileCount();
                    }
                    else
                    {
                      this.presentFailedSubmissionAlert('Error','There was a problem removing your billing file:<br><br>'+res.error.message);
                    }
                  },
                  (err) => { 
                    this.presentFailedSubmissionAlert('Error','There was a problem removing your billing file.');
                  }    
                );
              }
            },
          },
        ],
      });
  
      await alert.present();
    }

    /* async deleteFile(i)
    {

      const alert = await this.alertController.create({
        header: 'Confirm Delete',
        message: 'Are you sure you want to remove this Billing File?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
            },
          },
          {
            text: 'Yes',
            role: 'confirm',
            handler: () => {
              this.files.splice(i, 1);
              this.fileCount = this.files.length;
            },
          },
        ],
      });
      await alert.present();
    } */
    


    cancelFileSubmission() {
      this.isFileSubmissionModalOpen = false;
    }
    openFileSubmission() {
      //console.log('file?');
      this.isFileSubmissionModalOpen = true;
      //this.modalFileSubmissions.present();
    }

    submitBilling() {

      //change the status of the submission to ready as we would already have a saved status submission
      var params;  
      params = {
        isportal: 'true',
        comments: this.submissionForm.value.comments,
        submissionid: this.currentSavedSubmission,
      };  
      // Show loading spinner
      let loading = null;
      this.loadingController.create({
        message: 'Please wait while we submit your billing.',
        spinner: "circles"
        // You can customize options here
      }).then((loadingInstance) => {
        loading = loadingInstance;
        loading.present();
        this.isFileSubmissionModalOpen = false;
      
      this.apiService.post('submission_submit', params).subscribe(
        (res) => {
          if (res.error === false) {
            loading.dismiss();
            this.presentSuccessfulSubmissionAlert(null,'You have successfully submitted billing to Medbill. You will receive a confirmation email shortly.<br><br>Submission reference: '+res.submissionid+'<br>Billing Sheets: '+res.pagecount, true); 
          }
          else
          {
            loading.dismiss();
            this.presentFailedSubmissionAlert('Submission Error','There was a problem with your submission:<br><br>'+res.error.message);
          }
        },
        (err) => { 
          loading.dismiss();
          this.presentFailedSubmissionAlert('Submission Error','There was a problem with your submission.');
        }    
      );
      this.submissionForm.reset(); 
      
    });
  }
    /* OLD
    submitBilling() {
      if (this.files.length > 0) {  
        // Show loading spinner
        let loading = null;
        this.loadingCtrl.create({
          message: 'Please wait...',
          // You can customize options here
        }).then((loadingInstance) => {
          loading = loadingInstance;
          loading.present();
        });
        this.submissionForm.controls.User.setValue(this.user);
        this.submissionForm.controls.version.setValue(this.thisVersion);
        //console.log('Basic form file', this.basicForm.value);
        let successfulSub = false;
        let alertMessage = 'There was an unknown problem with your submission.';
        //console.log(this.submissionForm.value);
        this.apiService.post('portal_submission', this.submissionForm.value).subscribe(
          (res) => {
            //console.log(res);
            if (res.error === false) {
              successfulSub = true;
              this.files = [];
              this.fileCount=0;
              loading.dismiss();
              this.isFileSubmissionModalOpen = false;
              let messagecount = res.data.imageCount+' file';
              if (res.data.imageCount > 1)
              {
                messagecount = res.data.imageCount+' files';
              }
              this.presentSuccessfulSubmissionAlert('Submission Successful','You have successfully submitted '+ messagecount +' to Medbill. You will receive a confirmation email shortly.<br><br>Submission reference: '+res.data.id+'<br>Billing Sheets: '+res.data.pages);
            
            }
            else
            {
              loading.dismiss();
              this.presentFailedSubmissionAlert('There was a problem with your submission:<br><br>'+res.error.message);
            }
          },
          (err) => { 
            loading.dismiss();
            this.presentFailedSubmissionAlert('There was a problem with your submission.<br><br>It may be too large or contains too many images.');
          }
        );
        this.submissionForm.reset(); 
        
      } else {
        this.presentAlertConfirm();
      }
    } */
    
    async updateTheComments()
    {
      var params;  
      params = {
        comments: this.submissionForm.value.comments,
        submissionid: this.currentSavedSubmission,
      };  
      // Show loading spinner
      let loading = null;
      this.loadingController.create({
        message: 'Please wait while we update your submission.',
        spinner: "circles"
        // You can customize options here
      }).then((loadingInstance) => {
        loading = loadingInstance;
        loading.present();
        this.apiService.post('submission_update_comments', params).subscribe(
          (res) => {
            //console.log(res);
            if (res.error === false) {
              loading.dismiss();
              this.presentSuccessfulSubmissionAlert('Saved','Submission saved successfully!', false);
            }
            else
            {
              loading.dismiss();
              this.presentFailedSubmissionAlert('Submission Error','There was a problem saving your submission:<br><br>'+res.error.message);
            }
          },
          (err) => { 
            loading.dismiss();
            this.presentFailedSubmissionAlert('Submission Error','There was a problem with your submission.');
          }    
        );
      });
    }
    async save() {

      if (!this.currentSavedSubmission)
      {
        await this.createSubmission();
        this.presentSuccessfulSubmissionAlert('Updated Successfully','Submission saved successfully.', false);

      }
      else
      {
        await this.updateTheComments();

      }
      this.isFileSubmissionModalOpen = false;
      //console.log('save');
    }

    async createSubmission() {
      //create submission
      this.apiService.post('submission_new', this.submissionForm.value).subscribe(
        (res) => {
          if (res.error === false) {
            this.currentSavedSubmission = res.submissionid;
            this.submissionForm.controls.submissionid = this.currentSavedSubmission;
            this.submissionState = 'Resume Submission '+this.currentSavedSubmission;
            this.buttonSubmissionState = 'Resume Submission';
            this.submissionButtonIcon = "play-circle";
          }
        },
        (err) => { }
      );
    }

    async submit() {
      await this.getSubmissionInfo();

      this.submissionForm.controls.images.setValue(this.files);
      //console.log(this.files);
    if (this.submissionForm.valid) {
      const alert = await this.alertController.create({
        cssClass: 'success_alert', 
        header: 'Please Confirm',
        mode:'ios',
        animated: true,
        message: (this.files.length==1?'Please check your billing files before submitting!<br><br>Are you sure you want to submit<br><span class="yellow"><strong>one billing sheet file</strong></span><br>with submission '+this.currentSavedSubmission+'?  Please note that you can attach more than one billing file and submit them together in one submission.':'Please check your billing files before submitting!<br><br>Are you sure you want to submit<br><span class="yellow"><strong>'+ this.files.length +' billing sheet files</strong></span><br>with submission '+this.currentSavedSubmission+'?')+' <br><br>After you tap submit, please wait until you receive confirmation of a successful submission.',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'red',
            handler: (blah) => {
            }
          }, {
            text: 'Submit',
            cssClass: 'buttonUpdate',
            handler: () => {
              this.submitBilling();
            }
          } 
      
      ] });
      await alert.present();


      
    }
    else
    {

      if (this.files.length <= 0) {  
        this.presentAlertConfirm();
      }
    }
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'missingAlert',
      header: 'Missing Billing File',
      message: 'You must attach a Billing File before you can Submit.',
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          },
        },
      ],
    });

    await alert.present();
  }

  async presentSuccessfulSubmissionAlert(alertheader, alertmsg, redirect:boolean) {
    const alert = await this.alertController.create({
      cssClass: 'success_alert', 
      header: alertheader,
      message: alertmsg,
      buttons: [
        {
          text: 'OK',
          handler: () =>
          {
            //console.log('ok');
            if (redirect)
            {
              this.router.navigateByUrl('/web');  
            }
          }
        }
      ]
    });
    await alert.present();
  }

  async presentFailedSubmissionAlert(header,alertmsg) {

    const alert = await this.alertController.create({
      cssClass: 'fail_alert', 
      header: header,
      message: alertmsg,
      buttons: ['OK'],
    });
    await alert.present();
  }
  
  checkSavedSubmissions() {
    this.savedCount = 0;
    var params;  
    params = {
      isportal: 'true',
    };  
    this.apiService
      .post('data/check-saved-submissions', params)
      .subscribe(
        (res) => {
          if (res.error === false) {
            this.savedCount = res.data.saved_count;
            if (this.savedCount > 0)
            {
              this.currentSavedSubmission = res.data.submissionid;
              this.submissionForm.controls.submissionid = this.currentSavedSubmission;
              this.getSubmissionInfo();
              
              this.submissionState = 'Resume Submission '+this.currentSavedSubmission;
              this.buttonSubmissionState = 'Resume Submission';
              this.submissionButtonIcon = "play-circle";
            }
          }
        },
        (err) => {
          //console.log(err);
        }
      );
  }

  getSubmissionInfo() {
    var params;  
    params = {
      action: '',
      submission_id: this.currentSavedSubmission,
    };  
  
    this.apiService.post('data/getSubmission', params).subscribe(
      (res) => {
        this.files=[];
        //console.log(res);
        if (res.error === false) {
          this.submissionForm.controls.comments.setValue(res.data.Data.comments);
        
          let pages = res.data.Page;
          pages.forEach(page => {
            if (page.filename) 
            {
              var file = {            
                preview: this.imgBaseUrl + page.filename,
                fileId: page.id,
                name: page.filename,
                originalname: page.originalname
              }
              
              this.files.push(file);
              this.updateFileCount();
            }
          });       
                 
        }
      },
      (err) => {
      }
    );
  }

  updateFileCount() {
    this.fileCount = this.files.length;

  }

  logout() {
    this.apiService.weblogout();
    this.navCtrl.navigateRoot('/web', { animated: true });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event): void {
    // Call the logout function when the user closes the window
    this.logout();
  }
}
